export default "__VITE_ASSET__DAmIt0r9__"